<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="customerIdentification"
    track-by="customerId"
    :options="candidates"
    :searchable="true"
    :disabled="!editable"
    :allow-empty="false">
    <template #placeholder>
      {{ $t('common.SelectOne') }}
    </template>
  </v-multiselect>
</template>
<script>
export default {
  name: 'CustomerPartnerCandidateInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    candidates: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    fieldModelValue: {
      get() {
        return (
          this.candidates.filter((x) => x.customerId === this.value));
      },
      set(newValue) {
        this.$emit('input', newValue.customerId);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
